export const SET_LOADING = "SET_LOADING";
export const FETCH_LIST = "FETCH_LIST";
export const ADD_LIST = "ADD_LIST";

